module.exports = __webpack_public_path__ + "img/empty-orders.cb17806a.svg";